module.exports = __webpack_public_path__ + "assets/img/order-details-bg.282ac81a.png";